import { Routes } from 'react-router-dom';
import { useAppRoutes, useLoginRedirect } from 'hooks';

export default function AppRoutesComponent() {
  useLoginRedirect();
  const routes = useAppRoutes();
  return <Routes>{routes}</Routes>;
}
